module.exports = "/_next/static/images/FrameMobile-8ef47991ce2f28ec350cf497dee5301e.png";